import routeConfig from "@config/routes";
import { ChevronRight, Upload } from "@mui/icons-material";
import { Box, Button, Stack, Typography } from "@mui/material";
import useTranslations from "containers/hooks/useLanguageHook";
import { Link } from "react-router-dom";
import { useAppDispatch } from "@/index";
import { loadSampleDataset } from "@/store/fileParsing/actions";
import { ResponsiveButton } from "./ResponsiveButton";

function NoDataComponent() {
  const { t } = useTranslations();
  const dispatch = useAppDispatch();
  return (
    <Box
      sx={{
        transform: `translate(0px,${Math.max(0, window.innerHeight / 2)}px)`,
      }}
    >
      <Typography variant="h3" align="center">
        {t.DataPage.NoDataFound}
      </Typography>

      <Stack sx={{ pt: 4 }} direction="row" spacing={2} justifyContent="center">
        <Button component={Link} size="large" variant="contained" color="primary" to={routeConfig.Application}>
          {t.LandingPage.LoadDataNow} <ChevronRight />
        </Button>
        <ResponsiveButton
          variant="contained"
          color="primary"
          onClick={() => dispatch(loadSampleDataset())}
          text={t.DataPage.DemoDataset}
          icon={<Upload />}
          breakpoint={"md"}
          sx={{ m: 1 }}
        />
      </Stack>
    </Box>
  );
}

export default NoDataComponent;
